"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Size", {
  enumerable: true,
  get: function get() {
    return _types.Size;
  }
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("./styled/Icon"));

var _propTypes2 = require("./propTypes");

var _types = require("./types");

var Icon = function Icon(_ref) {
  var color = _ref.color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? _types.Size.SMALL : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["color", "size"]);
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    $color: color,
    $size: size
  }, props));
};

Icon.SIZE = _types.Size;
Icon.propTypes = {
  glyph: _propTypes2.propTypes.glyph.isRequired,
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(Object.values(_types.Size))
};
Icon.defaultProps = {
  size: _types.Size.SMALL,
  color: undefined
};
var _default = Icon;
exports["default"] = _default;